import React, { useEffect, useRef } from "react";
import styles from "./styles/HighInterestModal.module.css";
import { useLanguage } from "../LanguageContext";

const HighInterestModal = ({ onClose }) => {
    const modalRef = useRef(null);
    const { t } = useLanguage();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    return (
        <div className={styles.overlay}>
            <div className={styles.modal} ref={modalRef}>
                <button className={styles.close} onClick={onClose}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L13 13" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13 1L1 13" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                <div className={styles.icon}>
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M39.9992 80C61.8435 80 80 61.8824 80 40C80 18.1561 61.8034 0 39.959 0C18.0779 0 0 18.1561 0 40C0 61.8824 18.1163 80 39.9992 80ZM39.9624 45.883C37.8825 45.883 36.7464 44.6666 36.666 42.5868L36.1172 23.2176C36.0386 21.0591 37.6851 19.5315 39.9205 19.5315C42.1175 19.5315 43.8025 21.0993 43.7255 23.2561L43.175 42.5901C43.0964 44.7068 41.9201 45.8847 39.9607 45.8847M39.9607 60.3162C37.6851 60.3162 35.5667 58.5125 35.5667 56.0796C35.5667 53.6468 37.6466 51.8464 39.9607 51.8464C42.2346 51.8464 44.3513 53.61 44.3513 56.0796C44.3513 58.551 42.1945 60.3162 39.9607 60.3162Z"
                            fill="#CFFB13"
                        />
                    </svg>
                </div>
                <h2 className={styles.title}>{t("modal.title")}</h2>
                <p className={styles.description}>{t("modal.description")}</p>
            </div>
        </div>
    );
};

export default HighInterestModal;
